// extracted by mini-css-extract-plugin
export default {"wrapper":"ShareOnePage_wrapper__KOILo","menuWrapper":"ShareOnePage_menuWrapper__b1q5j"};